import { ENV } from "../utils";

export class User {
  baseApi = ENV.BASE_API;

  async getMe(accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.USER_ME}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async createUser(accessToken, data) {
    try {
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        if (key === "sites") {
          formData.append("sites", JSON.stringify(data.sites || []));
        } else {
          formData.append(key, data[key]);
        }
      });

      if (data.fileAvatar) {
        formData.append("avatar", data.fileAvatar);
      }

      // const url = `${this.baseApi}/${ENV.API_ROUTES.USER}`;
      const url = `${this.baseApi}/add-user`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getUsers(accessToken, active = undefined) {
    try {
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USERS}?active=${active}`;
      const url = `${this.baseApi}/users?active=${active}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateOwnProfile(accessToken, userData) {
    try {
      const formData = new FormData();
      Object.keys(userData).forEach((key) => {
        formData.append(key, userData[key]);
      });
      if (userData.fileAvatar) {
        formData.append("avatar", userData.fileAvatar);
      }

      const url = `${ENV.BASE_API}/user/me`;
      const params = {
        method: "PATCH",
        headers: { Authorization: `Bearer ${accessToken}` },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateUser(accessToken, idUser, userData) {
    try {
      const data = userData;
      if (!data.password) {
        delete data.password;
      }

      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        if (key === "sites") {
          formData.append("sites", JSON.stringify(data.sites || []));
        } else {
          formData.append(key, data[key]);
        }
      });

      if (data.fileAvatar) {
        formData.append("avatar", data.fileAvatar);
      }

      // const url = `${ENV.BASE_API}/${ENV.API_ROUTES.USER}/${idUser}`;
      const url = `${ENV.BASE_API}/update-user/${idUser}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteUser(accessToken, idUser) {
    try {
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USER}/${idUser}`;
      const url = `${this.baseApi}/delete-user/${idUser}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async verifyEmailApi(data) {
    const url = `${this.baseApi}/verify-email`;
    const params = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    };
    //console.log(data);

    return fetch(url, params)
      .then((response) => {
        //console.log("api response");
        //
        return response.json();
      })
      .then((result) => {
        //console.log("api result");
        //console.log(result);
        if (result.message === "e-mail encontrado") {
          return {
            ok: true,
            message: "¡e-mail encontrado!",
          };
        }
        return {
          ok: false,
          message: result.message,
        };
      })
      .catch((err) => {
        return {
          ok: false,
          message: err.message,
        };
      });
  }

  async sendEmail(data) {
    const url = `${this.baseApi}/send-email`;
    const params = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    };

    return fetch(url, params)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result.code === 200) {
          return {
            ok: true,
            code:200,
            message: result.message,
          };
        }
        return {
          ok: false,
          code:result.code,
          message: result.message,
        };
      })
      .catch((err) => {
        return {
          ok: false,
          message: err.message,
        };
      });
  }

  async updatePasswordByTokenApi(user, resetToken) {
    const url = `${this.baseApi}/update-password-by-token/${resetToken}`;
    const params = {
      method: "PUT",
      body: JSON.stringify(user),
      headers: {
        "Content-Type": "application/json",
      },
    };

    return fetch(url, params)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err;
      });
  }

  async getUsersByCompany(accessToken, companyId,active = undefined) {
    try {
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USERS}?active=${active}`;
      const url = `${this.baseApi}/users-company/${companyId}?active=${active}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getUsersBySite(accessToken, siteId,active = undefined) {
    try {
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USERS}?active=${active}`;
      const url = `${this.baseApi}/users-site/${siteId}?active=${active}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

   async getUserByResetTokenApi(resetToken) {
      const url = `${this.baseApi}/user-by-reset-token/${resetToken}`;
      const params = {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
          }
      };
  
      return fetch(url, params)
          .then(response => {
              //return res.redirect('/login');
              //res.render('/reset', {
              //    user: req.user
              //});
              return response.json();
          })
          .then(result => {
              //console.log("result: ", result);
              return result;
          })
          .catch(err => {
              //console.log(err);
              return err.message;
          });
  }

  async inviteUser(accessToken, data) {
    try {
      const url = `${this.baseApi}/invite-user`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getInviteByToken(token) {
    try {
      const url = `${this.baseApi}/invite/${token}`;
      const response = await fetch(url);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async completeInvite(token, data) {
    try {
      const url = `${this.baseApi}/invite/${token}/complete`;
      const params = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getUsersByStatus(accessToken, status) {
    try {
      const url = `${this.baseApi}/users?status=${status}`;
      const params = {
        headers: { Authorization: `Bearer ${accessToken}` },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateNotificationSettings(accessToken, data) {
    try {
      const url = `${this.baseApi}/user/notification-settings`;
      const params = {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getUsersByCompanyAndStatus(accessToken, companyId, status) {
    try {
      const url = `${this.baseApi}/users-company/${companyId}?status=${status}`;
      const params = {
        headers: { Authorization: `Bearer ${accessToken}` },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

}
